import React, { useState } from 'react';
import { callAPI } from '../components/utils';
import AuthLayout from '../components/layouts/authLayout';
import TextInput from '../components/ui/textInput';
import Button from '../components/ui/button';
import Alert from '../components/ui/alert';
import {
  Box,
  CircularProgress,
  Divider,
  Link as MuiLink,
  Stack,
} from '@mui/material';
import { Link } from 'react-router-dom';
import { ArrowBack } from '@mui/icons-material';

const ForgotPasswordPage = () => {
  const [email, setEmail] = useState('');
  const [message, setMessage] = useState('');
  const [errorMessage, setErrorMessage] = useState('');
  const [loading, setLoading] = useState(false);

  const handlePasswordResetRequest = async (event) => {
    event.preventDefault();
    setLoading(true);
    setErrorMessage('');
    setMessage('');

    try {
      await callAPI({
        request: 'forgotPassword',
        method: 'post',
        params: { email },
        onSuccess: () => {
          setMessage(
            'Password reset instructions have been sent to your email if it exists.'
          );
        },
        onError: (error) => {
          setErrorMessage(
            'Error sending password reset email. Please try again.'
          );
          console.error('Forgot Password Error:', error.response.data);
        },
      });
    } catch (error) {
      setErrorMessage('An error occurred while requesting a password reset.');
      console.error('Forgot Password API Error:', error);
    } finally {
      setLoading(false);
    }
  };

  return (
    <AuthLayout
      title="Forgot Password"
      description="Enter your email to reset your password"
    >
      <form onSubmit={handlePasswordResetRequest}>
        <Stack spacing={2.5}>
          <TextInput
            // label="Email"
            placeholder="Enter your email"
            type="email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            required
          />
          {message && (
            <Alert type="success" message={message} />

          )}
          {errorMessage && (
            <Alert type="error" message={errorMessage} />
          )}
          <Button
            type="submit"
            fullWidth
            variant="contained"
            bgColor="#172242"
            disabled={loading}
          >
            {loading ? (
              <CircularProgress
                size={24}
                sx={{
                  color: 'var(--navyBlue-default)',
                  position: 'absolute',
                  top: '50%',
                  left: '50%',
                  marginTop: '-12px',
                  marginLeft: '-12px',
                }}
              />
            ) : (
              'Send Reset Email'
            )}
          </Button>
        </Stack>
      </form>

      <Divider sx={{ bgcolor: 'var(--gray-300)', my: 3 }} />

      <Box
        sx={{
          mt: 2,
        }}
      >
        <MuiLink
          component={Link}
          to="/login"
          underline="hover"
          sx={{
            textDecoration: 'none',
            color: 'var(--navyBlue-default)',
            fontWeight: '600',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
          }}
        >
          <ArrowBack
            sx={{
              mr: 1,
              color: 'var(--navyBlue-default)',
            }}
          />
          Back to login
        </MuiLink>
      </Box>
    </AuthLayout>
  );
};

export default ForgotPasswordPage;
